<template>
  <div>
    <menu-pae />

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item">Elaboração</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-2">
      <filtro-pesquisa-processo class="p-2"
        :rowsNumber="10"
        :eventBusDataName="eventBusDataName"
        :eventBusPaginationName="eventBusPaginationName"/>
    </div>

    <div class="container-xl">
      <data-table-consulta-comp class="p-2"
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :renderizarCheckBox=true
        :dataTableColumn="dataTableColumn"
        :colWidth="colWidth"
        :disableCheckbox="disableCheckbox"
        :subtable="subtable">
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important; white-space: nowrap;">
            <i
              v-if="disableButtomVisualizar(slotProps.itemData)"
              v-tooltip.auto-start="`Visualizar Processo ${slotProps.itemData.numeroProcesso}`"
              class="fa fa-search fa-1-5x text-info m-1 link"
              aria-hidden="true"
              v-on:click="visualizar(slotProps.itemData)"
            ></i>
            <i
              v-if="disableButtomEditar(slotProps.itemData)"
              v-tooltip.auto-start="`Editar Processo ${slotProps.itemData.numeroProcesso}`"
              class="fa fa-pencil-square-o fa-1-5x text-primary m-1 link"
              aria-hidden="true"
              v-on:click="editar(slotProps.itemData)"
            ></i>
            <i
              v-if="disableButtomRemover(slotProps.itemData)"
              v-tooltip.auto-start="`Excluir Processo ${slotProps.itemData.numeroProcesso}`"
              class="fa fa-trash-o fa-1-5x text-danger m-1 link"
              aria-hidden="true"
              @click.prevent="() => {
                guardarNumeroProcesso(slotProps.itemData)
                $refs.confirmacaoExclusao.openModal()
              }"
            ></i>
          </td>
        </template>
        <template v-slot:subtable="subtable">
          <i
            v-tooltip.auto-start="`Visualizar protocolo ${subtable.itemData.data ? subtable.itemData.data.protocolo : ''}`"
            class="fa fa-search fa-1-5x link m-1 text-info"
            aria-hidden="true"
            v-on:click="visualizarApensado(subtable.itemData)"
          ></i>
        </template>
      </data-table-consulta-comp>

      <div class="row btnAcoes">
        <button class="btn btn-outline-primary" @click.prevent="tramitar"> Tramitar </button>
      </div>
    </div>
    <modal ref="confirmacaoExclusao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Realmente deseja excluir o processo {{ numeroProcesso }}?</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.confirmacaoExclusao.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.confirmacaoExclusao.closeModal()">Cancelar</button>
          <button type="button" class="btn btn-outline-primary m-1" @click.prevent="excluir()">Confirmar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import filtroPesquisaProcesso from '@/components/filtro/FiltroPesquisaProcesso.vue'

import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsulta'

import eventBus from '@/uteis/eventBus'
import { componentIsVisible, rules } from '@/uteis/action/permissao'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'

import modal from '@/components/shared/Modal.vue'

export default {
  name: 'consultarElaboracao',
  components: {
    menuPae,
    filtroPesquisaProcesso,
    dataTableConsultaComp,
    modal
  },

  data () {
    return {
      colNames: ['Data Criação', 'Nº Protocolo', 'Tipo Protocolo', 'Assunto', 'Interessados', 'Ações'],
      eventBusDataName: 'consultaProcessoElaboracaoData',
      eventBusPaginationName: 'consultaProcessoElaboracaoDataPagination',
      colWidth: [10, 10, 15, 30, 25, 10],
      dataTableColumn: [
        {
          column: 'atributos.dataCriacao',
          converter: 'localDate'
        },
        {
          column: 'atributos.numeroProcesso',
          converter: 'protocolo'
        },
        'atributos.tipoProtocolo',
        'atributos.assunto',
        {
          column: 'atributos.interessados.[nome]',
          converter: 'interessados'
        }],
      subtable: {
        field: 'processosApensados',
        column: [
          {
            $set: 'Apenso'
          },
          {
            column: 'protocolo',
            converter: 'protocolo'
          },
          'tipoProtocolo',
          'assunto', {
            column: 'interessados.[nome]',
            converter: 'interessados'
          }
        ]
      }
    }
  },

  created () {
    this.processoElaboracaoService = new ProcessoElaboracaoService()
  },

  methods: {
    visualizarApensado (obj) {
      var data = obj.data
      var disable = true
      this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
        volume: data.tipoProtocolo === 'Processo',
        anexar: true,
        protocoloTipoProcesso: data.tipoProtocolo === 'Processo'
      })
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          numeroProcesso: data.protocolo.replace(/\//g, ''),
          disableMenuProcesso: disable,
          tramitado: true
        }
      })
    },

    visualizar (obj) {
      var disable = (this.isApensado(obj) || this.isAnexado(obj))
      this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
        volume: obj.atributos.tipoProtocolo === 'Processo',
        editarProtocolo: true,
        protocoloTipoProcesso: obj.atributos.tipoProtocolo === 'Processo'
      })
      this.$router.push({ name: 'visualizadorProcesso', query: { numeroProcesso: obj.numeroProcesso.replace(/\//g, ''), disableMenuProcesso: disable } })
    },

    editar (obj) {
      this.$router.push({ name: 'manterElaboracao', query: { numeroProcesso: obj.numeroProcesso.replace(/\//g, '') } })
    },

    excluir () {
      const dadosSessao = this.$store.getters.getDadosSessao.sessao
      this.processoElaboracaoService.excluirProcesso(this.numeroProcesso.replace(/\//g, ''), dadosSessao.login).then(() => {
        eventBus.$emit(this.eventBusPaginationName, 1)
        this.$refs.confirmacaoExclusao.closeModal()
      }).catch(err => {
        console.log(err)
      })
    },

    disableButtomVisualizar (obj) {
      if (!obj.atributos) {
        return false
      }

      return true
    },

    disableCheckbox (protocolo) {
      if (!protocolo.data || !protocolo.data.atributos) {
        return false
      }

      return !(this.isApensado(protocolo.data) || this.isAnexado(protocolo.data))
    },
    disableButtomEditar (obj) {
      if (!obj.atributos) {
        return false
      }

      if (this.isApensado(obj) || this.isAnexado(obj)) {
        return false
      }

      if (obj.atributos.tipoProtocolo !== 'Processo') {
        return true
      }

      const { ACESSAR_EDITAR_PROTOCOLO } = rules
      return componentIsVisible(ACESSAR_EDITAR_PROTOCOLO)
    },
    disableButtomRemover (obj) {
      if (!obj.atributos) {
        return false
      }

      if (this.isIntegracao(obj)) {
        return false
      }
      if (this.isApensado(obj) || this.hasApensados(obj) || this.isAnexado(obj) || this.hasAnexados(obj)) {
        return false
      }

      if (obj.atributos.tipoProtocolo !== 'Processo') {
        return true
      }

      const { EXCLUIR_PROTOCOLO } = rules
      return componentIsVisible(EXCLUIR_PROTOCOLO)
    },
    isIntegracao: (obj) => obj.atributos.tipoProcesso && obj.atributos.tipoProcesso === 'SISTEMICO',
    hasApensados: (obj) => obj.apensados && obj.apensados.length > 0,
    isApensado: (obj) => obj.apensadoEm && obj.apensadoEm !== '',
    isAnexado: (obj) => obj.anexadoEm && obj.anexadoEm !== '',
    hasAnexados: (obj) => obj.anexados && obj.anexados.length > 0,

    tramitar () {
      const processosSelecionados = this.$store.getters.getDataTableChecked
      if (processosSelecionados.length > 0) {
        var numeroProcessos = processosSelecionados.map((data) => data.data.numeroProcesso)
        this.$store.commit('MUT_PROCESSOS_TRAMITACAO', numeroProcessos)
        this.$router.push({ name: 'tramite' })
      }
    },

    guardarNumeroProcesso (obj) {
      this.numeroProcesso = obj.numeroProcesso
    }
  }
}
</script>

<style scoped>
</style>
